var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 441.6 441.6",
    style: {
      enableBackground: "new 0 0 441.6 441.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2C6CFF;stroke:#2C6CFF;stroke-width:31;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#595757;stroke-width:31;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M220.8,28.5v73.3h-83.6V28.5c0-7.2,5.8-13,13-13h57.7C215,15.5,220.8,21.3,220.8,28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.8,114.7v298.4c0,7.2-5.8,13-13,13H114.8c-7.2,0-13-5.8-13-13V114.7c0-7.2,5.8-13,13-13h212.1 C334,101.8,339.8,107.6,339.8,114.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/기계.4a9ced53c1e8d9670440054bf4018480.svg";
export { ForwardRef as ReactComponent };